<script lang="ts" setup>
import { MagnifyingGlassIcon } from '@heroicons/vue/24/outline'
import { t } from '@/Support/lang'
import { computed, ref, watch } from 'vue'

interface Props {
  placeholder?: string
  mainClass?: string
  inputClass?: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  placeholder: 'Search',
  mainClass: 'text-white',
  inputClass: 'text-white placeholder-white',
  disabled: false,
})
const mainClass = computed(() => props.mainClass || 'text-white')

const search = ref<string | null>(null)
const emit = defineEmits<{
  (e: 'change', value: string | null): void
}>()
const emitSearch = () => {
  emit('change', search.value)
}
watch(search, (newValue, oldValue) => {
  if (oldValue && !newValue) {
    emit('change', search.value)
  }
})
</script>

<template>
  <div class="max-w-xs mx-auto w-full lg:max-w-md">
    <label class="sr-only" for="search">
      {{ __('Search') }}
    </label>
    <div class="relative focus-within:text-neutral-600" :class="mainClass">
      <div
        class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center"
      >
        <MagnifyingGlassIcon
          aria-hidden="true"
          class="h-5 w-5"
          @click="emitSearch"
        />
      </div>
      <input
        id="search"
        v-model="search"
        :placeholder="__(placeholder)"
        :disabled="disabled"
        class="block w-full bg-white/20 dark:bg-neutral-800/20 py-2 pl-10 pr-3 border border-transparent rounded-md leading-5 focus:text-neutral-900 dark:focus:text-neutral-300 focus:outline-hidden focus:bg-white dark:focus:bg-neutral-800 focus:border-transparent focus:placeholder-neutral-500 focus:ring-0 sm:text-sm"
        :class="inputClass"
        name="search"
        type="search"
        @keydown.enter="emitSearch"
        @input="emitSearch"
      />
    </div>
  </div>
</template>
